import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'src/app/shared/message.service';
import { StoreService } from 'src/app/shared/store.service';

@Component({
  selector: 'rpms-controlled-store-diagram',
  templateUrl: './controlled-store-diagram.component.html',
  styleUrls: ['./controlled-store-diagram.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ControlledStoreDiagramComponent implements OnInit {
  @Input() stores: any[];
  @Input() store: any;
  @Output() shouldControlledStorePricingColumnBeVisibleEvent = new EventEmitter<boolean>();

  storeGroupDiagramHtml = '<div id="controlled-store-diagram">Test</div>';
  shouldDiagramBeVisible:boolean = false;

  constructor(
    private _storeService: StoreService,
    private _messageService: MessageService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('ON CHANGES');
    // console.log(this.stores);
    // console.log(this.store);
    if (this.store.storeId) this.getControlledStoreHierarchyByStoreId(this.store.storeId);
  }

  getControlledStoreHierarchyByStoreId(storeId){
    this._storeService.getControlledStoreHierarchyByStoreId(storeId)
    .subscribe(
      (data: any) => {
        //console.log(data);
        this.renderDiagram(data.stores);
        this.shouldDiagramBeVisible = true;
        this.shouldControlledStorePricingColumnBeVisibleEvent.next(true);
      },
      (response) => {
        this._messageService.onFailure('Failed to get store hierarchy.', response);
      })
  }

  renderDiagram(data) {
    var htmlString = '<div class="controlled-store-diagram">';
      for (let i=0; i<data.length; i++){
        let rootStore = data[i];
        //controlling store
        if (rootStore.controlledStores.length > 0) {
          let rootStoreClass = rootStore.active ? 'controlling-store' : 'controlling-store inactive';
          let rootStoreSuffix = rootStore.active ? '(Controlling)' : '(Controlling)(Not Active)';
          htmlString += `<div class="${rootStoreClass}">${rootStore.numberAndLocation} ${rootStoreSuffix}</div>`;
          htmlString += `<div class="controlled-store-wrapper">`;
          //controlled stores
          for (let j=0; j<rootStore.controlledStores.length; j++){
            let controlledStoreClass = rootStore.controlledStores[j].active ? 'controlled-store' : 'controlled-store inactive';
            let controlledStoreSuffix = rootStore.controlledStores[j].active ? '' : '(Not Active)';
            htmlString += `<div class="${controlledStoreClass}"><span>-</span> ${rootStore.controlledStores[j].numberAndLocation} ${controlledStoreSuffix}</div>`;
          }
          htmlString += `</div>`;
        }
        //not a controlling or controlled store
        else {
          let rootStoreClass = rootStore.active ? 'root-store' : 'root-store inactive';
          let rootStoreSuffix = rootStore.active ? '' : '(Not Active)';
          htmlString += `<div class="${rootStoreClass}">${rootStore.numberAndLocation} ${rootStoreSuffix}</div>`
        }
      }
    htmlString += `</div>`;
    this.storeGroupDiagramHtml = htmlString;
  }
  
  showDiagram(){
    let diagram:any = document.getElementById('store-diagram');
    if (diagram) {
      diagram.style.opacity = '1';
      diagram.style.transform = 'scale(1, 1)';
    }
  }

  hideDiagram(){
    let diagram:any = document.getElementById('store-diagram');
    if (diagram) {
      diagram.style.opacity = '0';
      diagram.style.transform = 'scale(.1, .1)';
    }
  }

}
